import one from '../assets/svg/projects/one.svg'
import two from '../assets/svg/projects/two.svg'
import three from '../assets/svg/projects/three.svg'
import four from '../assets/svg/projects/four.svg'
import five from '../assets/svg/projects/five.svg'
import six from '../assets/svg/projects/six.svg'
import seven from '../assets/svg/projects/seven.svg'
import eight from '../assets/svg/projects/eight.svg'


export const projectsData = [
    {
        id: 1,
        projectName: 'Oman Pakistan Embassy Application',
        projectDesc: 'This application is playing a vital role in order to handle all admin level activities like notification and news update and setting up pending status .',
        tags: ['React', 'Firestore' , 'Cloud Functions' ,'CSS', 'Javascript'],
        code: '',
        demo: 'https://pakistan-embassy-muscat-6280f.web.app/login',
        image: "https://raw.githubusercontent.com/MuhammadHamza12/portfolio/master/src/assets/project_1.png"
    },
    {
        id: 2,
        projectName: 'School Smart',
        projectDesc: 'This is complete school ERP system, including all modules Finance , LMS , CMS , TimeTable and Attendence and much more as well',
        tags: ['React','Nodejs','Javascript','MySQL'],
        code: '',
        demo: 'https://dak.schoolsmart.org.uk/',
        image: "https://raw.githubusercontent.com/MuhammadHamza12/portfolio/master/src/assets/project_2.png"
    },
    // {
    //     id: 21,
    //     projectName: 'Coinsiren',
    //     projectDesc: 'This is complete school ERP system, including all modules Finance , LMS , CMS , TimeTable and Attendence and much more as well',
    //     tags: ['React','Nodejs','Javascript','Firebase','Firebase Cloud Functions'],
    //     code: '',
    //     demo: 'https://dak.schoolsmart.org.uk/',
    //     image: "https://raw.githubusercontent.com/MuhammadHamza12/portfolio/master/src/assets/coinsiren.png"
    // },
    {
        id: 3,
        projectName: 'Daily Diary',
        projectDesc: 'This project is for noting down daily tasks, where user can create, update and delete their routine activities just like daily to do',
        tags: ['React Native', 'Async Storage','Native Base', 'React Navigation'],
        code: 'https://github.com/MuhammadHamza12/react-native-diary-app',
        demo: 'https://youtu.be/Vrs6jFw7KQ8',
        image: "https://raw.githubusercontent.com/MuhammadHamza12/portfolio/master/src/assets/daily_dairy.jpeg"
    },
    {
        id: 4,
        projectName: 'Oman Pakistan Embassy Application ( Mobile Version )',
        projectDesc: 'This is a mobile version of embassy portal which is for the end user, who will get updates , submit complaints and issues and get feedback from the concern authorities',
        tags: ['React Native', 'Firebase','React Navigation','Firebase Cloud Functions', 'Push notification'],
        code: 'https://github.com/MuhammadHamza12',
        demo: 'https://youtu.be/-Lsb--RTSXQ',
        image: "https://raw.githubusercontent.com/MuhammadHamza12/portfolio/master/src/assets/linkit.jpeg"
    },
    {
        id: 5,
        projectName: 'Beacon Secure',
        projectDesc: 'This application play role as a bridge in between patients and laboratory. Laboratory send test kits with the proper steps toward the patients and patients can get update about his result on the application without even go to the hospital',
        tags: ['React Native', 'UI Design', 'React Navigation'],
        code: 'https://github.com/MuhammadHamza12',
        demo: 'https://youtube.com/shorts/ciBF25b0mU8',
        image: "https://raw.githubusercontent.com/MuhammadHamza12/portfolio/master/src/assets/beacon.jpeg"
    },
    
]


// Do not remove any fields.
// Leave it blank instead as shown below

/* 
{
    id: 1,
    projectName: 'Car Pooling System',
    projectDesc: '',
    tags: ['Flutter', 'React'],
    code: '',
    demo: '',
    image: ''
}, 
*/